import { createContext } from "react";

export const TemplateContext = createContext();
